import {Utils} from './Utils';

const validator = {
  isNullOrEmpty(value) {
    if (!value || value === '') {
      return true;
    }
  },
  isEmailInValid(email) {
    return !Utils.validateEmail(email);
  },
};

export default validator;
